import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'jsonFilter', standalone: true })
@Injectable({providedIn: 'root'})
export class JsonFilterPipe implements PipeTransform {
	
	transform(input, jsonMatcher) {
		var result: Array<any> = [];
		var firstKey: any = Object.keys(jsonMatcher)[0];
		if (input && input.length > 0) {
			for(var i = 0; i < input.length; i++) {
				if (input[i].hasOwnProperty(firstKey) && input[i][firstKey] === jsonMatcher[firstKey]) {
					result.push(input[i]);
				}
			}
		}
		return result;
	}
	
}